<template>
	<div>
		<div class="modal-body pt-0">
			<div class="row justify-content-center">
				<!-- CHECK TO PRINT BEGIN -->
				<!-- <div class="col-md-5 p-0 print section-to-print">
					<div id="posCheck">
						<div id="depName" class="d-flex justify-content-center"><strong>DUTY-FREE - {{
								shopName
							}}</strong></div>
						<div id="depAddress" class="d-flex justify-content-center bottom-bordered"><i>{{
								shopAddress
							}}</i>
						</div>
						<div class="d-flex justify-content-between"><span>{{ dateTime }}</span> <span
							style="text-align: right;">{{ $t('sidebar.pos.check') }}: {{
								currentSuspendId ? currentSaleSuspendNumber : currentSaleNumber
							}}</span>
						</div>
						<div class="d-flex justify-content-between"><span>{{ $t('xAtchot.cashier') }}:{{
								cashierFullName
							}}</span> <span
							style="text-align: right;">POS №:{{ cashboxNumber }}</span></div>
						<div class="d-flex justify-content-between"
							 :class="returnItemsCount == 0 ? 'bottom-bordered' : ''">
							<span>{{ $t('pos.saller') }}:{{ currentSellerName }}</span> <span
							style="text-align: right;">{{ $t('pos.items') }}:{{ totalCount }}</span>
						</div>
						<div
							v-if="returnItemsCount !== 0"
							class="d-flex justify-content-end bottom-bordered">
							<span style="text-align: right;">Возврат кол-во:{{ returnItemsCount }}</span>
						</div>
						<div class="posCheckTable bottom-bordered">
							<table>
								<thead>
								<tr>
									<th class="alignedLeft" style="width: 45%; word-break: break-all;">
										{{ $t('pos.product') }}
									</th>
									<th class="alignedCenter" style="width: 17%; word-break: break-all;">
										{{ $t('sale.kol-vo') }}
									</th>
									<th class="alignedCenter" style="width: 17%; word-break: break-all;">
										{{ $t('sidebar.pos.sale') }}
									</th>
									<th class="alignedRight" style="width: 32%; word-break: break-all;">
										{{ $t('incomes.create.price') }} ({{ userDepCurrencyName }})
									</th>
								</tr>
								</thead>
								<tbody>
								<tr
									v-for="(item, index) in getCartItems"
									:key="'checkItem' + index"
									:class="item.count < 0 ? 'returnItemBordered' : ''"
								>
									<td class="alignedLeft" style="width: 45%; word-break: break-all;">
										<strong>{{ index + 1 }}.</strong>{{
											item.name
										}}/<strong>{{ item.artikul }}</strong>/{{ item.genderName }}/{{
											item.colorName
										}}/<strong>{{ item.size }}</strong>
									</td>
									<td class="alignedCenter" style="width: 17%; word-break: break-all;">
										{{ item.count > 0 ? item.count : -item.count }}
									</td>
									<td class="alignedCenter" style="width: 17%; word-break: break-all;">
										<template v-if="afterPromotionSum(item) > 0">
											{{
												afterPromotionSum(item) | currency({
													symbol: userDepCurrencyName,
													fractionCount: 2,
													symbolPosition: 'back'
												})
											}}
										</template>
										<template v-else-if="afterPromotionPercentage(item) > 0">
											{{
												afterPromotionPercentage(item) | currency({
													symbol: '%', symbolPosition: 'back'
												})
											}}
										</template>
										<template v-else> -</template>
									</td>
									<td class="alignedRight" style="width: 32%; word-break: break-all;">
										{{
											item.discountPriceUzs * item.count | currency({
												symbol: '', fractionCount: 2, symbolPosition:
													'back',
												thousandsSeparator: ''
											})
										}}<br>{{
											item.priceUzs * item.count | currency({
												symbol: '',
												fractionCount: 2,
												symbolPosition: 'back',
												thousandsSeparator: ''
											})
										}}
									</td>
								</tr>
								</tbody>
							</table>
						</div>
						<div class="posCheckTotal bottom-bordered">
							<table>
								<tbody>
								<tr>
									<td class="alignedLeft">{{ $t('warehouse.table.totalIncomeUzs') }}</td>
									<td class="alignedRight">{{
											parseFloat(totalSum) | currency({
												symbol: userDepCurrencyName, fractionCount: 2,
												symbolPosition:
													'back', thousandsSeparator: ''
											})
										}}
									</td>
								</tr>
								<tr>
									<td class="alignedLeft">{{ $t('pos.ndc') }}</td>
									<td class="alignedRight">{{
											parseFloat(totalSum) / 6 | currency({
												symbol: userDepCurrencyName, fractionCount: 2,
												symbolPosition:
													'back', thousandsSeparator: ''
											})
										}}
									</td>
								</tr>
								<tr>
									<td class="alignedLeft">{{ $t('xAtchot.pay') }}</td>
									<td class="alignedRight">{{
											parseFloat(totalSum) | currency({
												symbol: userDepCurrencyName, fractionCount: 2,
												symbolPosition:
													'back', thousandsSeparator: ''
											})
										}}
									</td>
								</tr>
								<tr>
									<td class="alignedLeft">{{ $t('sale.payed') }}</td>
									<td class="alignedRight">{{
											totalPaid | currency({
												symbol: userDepCurrencyName, fractionCount: 2, symbolPosition:
													'back', thousandsSeparator: ''
											})
										}}
									</td>
								</tr>
								<tr v-if="returnItemsSum !== 0" class="returnItemBordered">
									<td class="alignedLeft">ВОЗВРАТ</td>
									<td class="alignedRight">{{
											-returnItemsSum | currency({
												symbol: userDepCurrencyName, fractionCount: 2,
												symbolPosition:
													'back', thousandsSeparator: ''
											})
										}}
									</td>
								</tr>
								<tr v-if="parseFloat(sponsorshipAmount) > 0" class="returnItemBordered">
									<td class="alignedLeft">СПОНСОРСТВО</td>
									<td class="alignedRight">{{
											sponsorshipAmount | currency({
												symbol: userDepCurrencyName, fractionCount: 2,
												symbolPosition:
													'back', thousandsSeparator: ''
											})
										}}
									</td>
								</tr>
								<tr v-if="parseFloat(debtAmount) > 0">
									<td class="alignedLeft">ДОЛГ</td>
									<td class="alignedRight">{{
											debtAmount | currency({
												symbol: userDepCurrencyName, fractionCount: 2, symbolPosition: 'back',
												thousandsSeparator: ''
											})
										}}
									</td>
								</tr>
								<tr>
									<td class="alignedLeft">{{ $t('pos.no-check') }}</td>
									<td class="alignedRight" v-if="customPromotion">
										{{ customPromotion.discount }}
										<span v-if="customPromotion.promotionType == '%'">{{
												customPromotion.promotionType
											}}</span>
										<span v-else>{{ userDepCurrencyName }}</span>
									</td>
									<td class="alignedRight" v-else>{{
											0 | currency({
												symbol: '',
												symbolPosition: 'back', thousandsSeparator: ''
											})
										}}
									</td>
								</tr>
								</tbody>
							</table>
						</div>


						<div v-if="isOnlaynProdaja" class="posCheckTotalB bottom-bordered">
							<table>
								<tbody>
								<tr>
									<td class="alignedLeft">Номер заказа</td>
									<td class="alignedRight">
										{{ orderNumber }}
									</td>
								</tr>
								<tr>
									<td class="alignedLeft">Клиент</td>
									<td class="alignedRight">
										{{ clientName }}
									</td>
								</tr>
								<tr>
									<td class="alignedLeft">Контактный номер</td>
									<td class="alignedRight">
										{{ clientPhoneNumber }}
									</td>
								</tr>
								<tr>
									<td class="alignedLeft">Адрес доставки</td>
									<td class="alignedRight">
										{{ clientAddress }}
									</td>
								</tr>
								</tbody>
							</table>
						</div>

						<div class="posThanks">
							<p><i>-- {{ $t('pos.please') }}! --</i></p>
						</div>
					</div>
				</div> -->
				<!-- CHECK TO PRINT END -->
				<!-- <div class="col-md-12 p-0 hidden-print">
					<div class="box box-solid bg-orange">
						<div class="box-body row m-0 p-0">
							<div
								class="col-md-4 p-2 fs_1_2"
							>
								<span>
									{{ $t('xAtchot.item') }}
								</span>
								<br>
								<strong class="text-bold ">{{ totalCount }}</strong>
							</div>

							<div
								class="col-md-4 p-2 fs_1_2"
							>
								<span>
									{{ $t('xAtchot.pay') }}:
								</span>
								<br>
								<strong class="text-bold total_payable_span">{{
										totalSum | currency({
											symbol: userDepCurrencyName,
											fractionCount: 2,
											symbolPosition: 'back'
										})
									}}</strong>
							</div> -->
				<!--							<div class="col-md-12" style="padding: 10px; background: orange;">
												<strong>
													{{ $t('pos.no-check') }}:
												</strong>
												<br>
												<span class="lead text-bold total_payable_span" v-if="customPromotion">
													{{ customPromotion.discount }}
													<span v-if="customPromotion.promotionType == '%'">{{
															customPromotion.promotionType
														}}</span>
													<span v-else>{{ userDepCurrencyName }}</span>
												</span>
												<span class="lead text-bold total_payable_span" v-else>{{
														0 | currency({
															symbol: '',
															symbolPosition: 'back', thousandsSeparator: ' '
														})
													}}</span>
											</div>-->
				<!--			NEW CURRENCY ADD FOR SALE				-->
				<!-- <div
					class="col-md-4"
					style="background: #4DBD74;"
				>
					<label class="fs_1_2" for="saleCurrenciesSelect">{{ $t('department.money-type') + ':' }}</label>
					<multiselect
						id="saleCurrenciesSelect"
						v-model="saleCurrencies"
						:options="refCurrencies"
						multiple
						:placeholder="$t('department.money-type-department')"
						label="name"
						track-by="id"
						:show-labels="false"
					></multiselect> -->
				<!--								<b-form-group label-cols="12" label-size="sm"
															  :label="$t('department.money-type')+':'" label-for="saleCurrency">
													<b-form-select v-model="newCurrency"
																   @input="addNewCurrency"
																   size="sm" id="saleCurrency">
														<option
															v-for="(selectOption, indexOpt) in refCurrencies"
															:disabled="
																canSelectThisOption(
																  selectOption.id
																)
															  "
															:key="indexOpt"
															:value="selectOption.id"
														>
															{{ selectOption.name }}
														</option>
														<template slot="first">
															<option :value="null" disabled>{{ $t('department.money-type-department') }}
															</option>
														</template>
													</b-form-select>
												</b-form-group>-->
				<!-- </div> -->
				<!-- </div>
			</div>
		</div> -->
				<div class="col-md-12 pl-0 hidden-print">

					<payment-method
						:open-clicked="openClicked"
						:totalSum="totalSum"
						:sale-currencies="saleCurrencies"
						:last-currency-rates="lastCurrencyRates"
						@debtAmountChanged="setDebtAmount"
						@sponsorshipAmountChanged="setSponsorshipAmount"
						ref="paymentMethod"
					>
					</payment-method>

				</div>
			</div>
		</div>
		<div class="modal-footer pb-0 hidden-print">
			<button
				type="button"
				@click="close"
				class="btn btn-default"
				data-dismiss="modal"
			>
				{{ $t('xAtchot.close') }}
			</button>
			<!-- <button type="submit"
					@click="success(false)"
					class="btn btn-primary"
					id="pos-save-without-check"
					:disabled="posDisabled"
			>
				{{ $t('sale.no-check') }}
			</button> -->
			<button v-if="kkmBtn" @click="successKKM" style="font-size: 12px" class="btn btn-primary">Попробовать сново <br> последнюю продажу</button>
			<button v-else type="submit" @click="success(false)" class="btn btn-success" id="pos-save" :disabled="posDisabled">{{ $t('sale.check') }}</button>
		</div>
	</div>
</template>

<script>
import {mapActions, mapGetters, mapState} from 'vuex'
import Multiselect from "vue-multiselect"
import PaymentMethod from './blocks/PaymentMethod'

const sleep = (milliseconds) => {
	return new Promise(resolve => setTimeout(resolve, milliseconds))
}
export default {
	name: 'MultiplePay',
	props: {
		totalCount: [String, Number],
		totalSum: [String, Number],
		openClicked: [Boolean],
		kkmBtn: [Boolean],
		lastCurrencyRates: {
			type: Array,
			default: () => []
		}
	},
	components: {
		PaymentMethod,
		Multiselect
	},
	data: () => {
		return {
			saleCurrencies: [],
			newCurrency: null,
			dateTime: '',
			isMounted: false,
			debtAmount: 0,
			sponsorshipAmount: 0,
		}
	},
	computed: {
		...mapState('pos', [
			'shopName', 'currentSaleNumber',
			'shopAddress', 'cashierFullName', 'currentSellerName',
			'currentSaleSuspendNumber', 'currentSuspendId', 'customPromotion',
			'posDisabled', 'clientPhoneNumber', 'clientName', 'orderNumber', 'clientAddress', 'isOnlaynProdaja'
		]),
		...mapState('references', [
			'allPaymentMethods', 'refCurrencies'
		]),
		...mapGetters('pos', [
			'getCartItems'
		]),
		...mapState('certificates', [
			'certificateForPos'
		]),
		...mapState([
			'cashboxNumber', 'userDepCurrencyName', 'userDepCurrencyCode'
		]),
		totalPaid() {
			if (this.isMounted) {
				return this.$refs.paymentMethod.totalPaid;
			}
		},
		returnItemsSum() {
			let sum = 0;
			this.getCartItems.forEach(el => {
				if (el.count < 0) {
					sum += el.count * el.discountPriceUzs;
				}
			});
			return sum;
		},
		returnItemsCount() {
			let count = 0;
			this.getCartItems.forEach(el => {
				if (el.count < 0) {
					count -= el.count;
				}
			});
			return count;
		},
	},
	methods: {
		...mapActions('references', [
			'loadPaymentMethods', 'getReferenceChildren'
		]),
		moveElementInArray(arr, from, to) {
			// Make sure a valid array is provided
			if (Object.prototype.toString.call(arr) !== '[object Array]') {
				throw new Error('Please provide a valid array');
			}

			// Delete the item from it's current position
			let item = arr.splice(from, 1);

			// Make sure there's an item to move
			if (!item.length) {
				throw new Error('There is no item in the array at index ' + from);
			}

			// Move the item to its new position
			arr.splice(to, 0, item[0]);
		},
		reorderAndAddCurrencies() {
			let ourCurrencyCodesWithOrderIndexes = [
				{
					code: 'EUR',
					orderIndex: 0
				},
				{
					code: 'USD',
					orderIndex: 1
				},
				{
					code: 'UZS',
					orderIndex: 2
				},
				{
					code: 'RUB',
					orderIndex: 3
				},
				{
					code: 'GBP',
					orderIndex: 4
				},
				{
					code: 'CNY',
					orderIndex: 5
				}
			]
			this.saleCurrencies = []
			this.saleCurrencies = [...this.refCurrencies]
			for (const eachCurrency of ourCurrencyCodesWithOrderIndexes) {
				let getIndex = this.saleCurrencies.findIndex(currency => currency.code === eachCurrency.code)
				if (getIndex > -1)
					this.moveElementInArray(this.saleCurrencies, getIndex, eachCurrency.orderIndex)
			}
		},
		afterPromotionSum(item) {
			let promoparam;
			if (item.promotions) {
				for (let i = 0; i < item.promotions.length; i++) {
					if (item.promotions[i].type == "PUL") {
						promoparam = item.promotions[i].value
					}
				}
				return promoparam;
			}
		},

		afterPromotionPercentage(item) {
			let promoparam1;
			if (item.promotions) {
				for (let i = 0; i < item.promotions.length; i++) {
					if (item.promotions[i].type == "%") {
						promoparam1 = item.promotions[i].value
					}
				}
				return promoparam1;
			}
		},
		close() {
			this.$emit('close')
		},
		setDebtAmount(debtAmount) {
			this.debtAmount = debtAmount;
		},
		setSponsorshipAmount(sponsorshipAmount) {
			this.sponsorshipAmount = sponsorshipAmount;
		},
		makeCurrentDateTime() {
			let now = new Date();
			let year = now.getFullYear();
			let month = now.getMonth() + 1;
			let day = now.getDate();
			let hour = now.getHours();
			let minute = now.getMinutes();
			let second = now.getSeconds();
			if (month.toString().length == 1) {
				month = '0' + month;
			}
			if (day.toString().length == 1) {
				day = '0' + day;
			}
			if (hour.toString().length == 1) {
				hour = '0' + hour;
			}
			if (minute.toString().length == 1) {
				minute = '0' + minute;
			}
			if (second.toString().length == 1) {
				second = '0' + second;
			}
			this.dateTime = year + '/' + month + '/' + day + ' ' + hour + ':' + minute + ':' + second;
		},
    successKKM() {
      this.$emit('successKKM');
    },
		async success(isCheck) {
			/*if (parseFloat(this.totalPaid) > parseFloat(this.totalSum)) {
				this.$vs.notify({
					title: 'Пожалуйста, заполните правильно',
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
				return
			}*/
			let paymentFinal = [];
			let paymentMethods = []
			this.$refs.paymentMethod.payments.forEach(eachPayment => {
				eachPayment.paymentMethods.forEach(method => {
						paymentMethods.push(method)
					}
				)
			})
			paymentMethods.forEach(payment => {
				let obj = {
					paymentTypeId: payment.paymentMethod ? payment.paymentMethod.id : null,
					paymentTypeCode: payment.paymentMethod ? payment.paymentMethod.code : null,
					value: payment.amount,
					comment: this.$refs.paymentMethod.paymentComment,
					currencyId: payment.currencyId,
					currencyRateId: payment.currencyRateId
				}
				if (payment.certificate) {
					obj.certificate = payment.certificate;
					obj.certificateId = this.certificateForPos ? this.certificateForPos.id : null;
				}
				if (obj.paymentTypeId && obj.value.toString().trim() !== '') {
					if (obj.value < 0) {
						if (this.totalPaid >= parseFloat(this.totalSum) - paymentMethods.find(el => el.paymentMethod.code == 'QARZGA').amount
							- paymentMethods.find(el => el.paymentMethod.code == 'HOMIYLIK').amount) {
							paymentFinal.push(obj)
						}
					} else if (obj.value === 0) {
						if (this.totalSum === 0) {
							paymentFinal.push(obj)
						}
					} else if (obj.value > 0) {
						paymentFinal.push(obj)
					}
				}
			})
			if (paymentFinal.length <= 0) {
				this.$vs.notify({
					title: 'Пожалуйста, заполните правильно!',
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
				this.$store.commit('pos/setPosDisabled', false);
			} else if (this.totalPaid < this.totalSum - 3) {
				let sum = (this.totalSum - 3 - this.totalPaid).toFixed(2);
				this.$vs.notify({
					title: 'Cумма платежа менее ' + sum,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
				this.$store.commit('pos/setPosDisabled', false);
			} else if (this.totalPaid > this.totalSum + 3) {
				let sum = (this.totalPaid - this.totalSum - 3).toFixed(2);
				this.$vs.notify({
					title: 'Cумма платежа более ' + sum,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
				this.$store.commit('pos/setPosDisabled', false);
			} else {
				this.$emit('success',
					isCheck,
					paymentFinal,
					this.totalPaid,
					paymentMethods.find(el => el.paymentMethod.code == 'QARZGA').amount,
					this.returnItemsCount,
					this.returnItemsSum,
					this.sponsorshipAmount
				);
			}

		},
	},
	/** --WATCHERS-- **/
	watch: {
		openClicked: {
			handler(newVal) {
				if (newVal) {
					this.$options.interval = setInterval(this.makeCurrentDateTime, 1000);
					this.reorderAndAddCurrencies()
				} else {
					clearInterval(this.$options.interval);
				}
			}
		}
	},
	/** --MOUNTED HOOK-- **/
	mounted() {
		this.makeCurrentDateTime();
		this.isMounted = true
	},
	/** --CREATED HOOK-- **/
	async created() {
		await this.getReferenceChildren('CURRENCY')
		await this.getReferenceChildren('BANK_CARD')
		await this.loadPaymentMethods()
		await this.reorderAndAddCurrencies()
	},

	/** --BEFORE DESTROY HOOK-- **/
	beforeDestroy() {
		clearInterval(this.$options.interval);
	}
}
</script>

<style scoped lang="scss">
// @import url("https://fonts.googleapis.com/css?family=Inconsolata");

.alignedLeft {
	text-align: left;
}

.alignedRight {
	text-align: right;
}

.alignedCenter {
	text-align: center;
}

#posCheck {
	border: 1px solid #aaa;
	box-shadow: 1px 2px 5px 2px #aaa;
	padding: 10px;
	height: 27rem;
	font-family: monospace;
	font-size: 13px;
	overflow-y: auto;
	width: 100mm;

	#depName {
		font-size: 18px;
	}

	.bottom-bordered {
		padding-bottom: 2px;
		border-bottom: 0.5px dashed #444;
	}

	table {
		width: 100%;
	}

	.returnItemBordered {
		border: 0.5px dotted black;
	}

	td,
	th {
		border: none;
	}

	.posCheckTotal {
		table {
			td {
				font-weight: bold;
				font-size: 13px;
			}
		}
	}

	.posCheckTotalB {
		table {
			td {
				font-weight: bold;
				font-size: 11px;
			}
		}
	}

	.posThanks {
		p {
			text-align: center;
			font-weight: bold;
			font-size: 13px;
		}
	}
}

.box-body {
	border-top-left-radius: 0;
	border-top-right-radius: 0;
	border-bottom-right-radius: 3px;
	border-bottom-left-radius: 3px;
	padding: 10px;
}

hr {
	margin-top: 20px;
	margin-bottom: 20px;
	border: 0;
	border-top: 1px solid #eee;
}

.bg-orange {
	background-color: #20a8d8 !important;

	.fs_1_2 {
		font-size: 1.3rem;
	}
}

/*@media print {
	.hidden-print {
		display: none;
	}

	.card {
		box-shadow: none;
	}
	body * {
		visibility: hidden;
	}
	#section-to-print, #section-to-print * {
		visibility: visible;
	}
	#section-to-print {
		position: absolute;
		left: 0;
		top: 0;
	}
}*/
</style>
